module.exports = __webpack_public_path__ + "img/Tablet - 35.c80e49fb.png";